export default __webpack_public_path__ + "static/b6-2c6ca26a29b216a9ec84c3ce2e76e4c1.png";